//

import AppendSCVariable from "@/components/SmartContractDesigner/AppendSCVariable/AppendSCVariable.vue";
import { mapGetters } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    name: "ExpressionHandler",
    components: {
        AppendSCVariable,
        AQInput
    },
    computed: {
        ...mapGetters("smartContractDesigner", ["selectedPluginData"])
    },
    props: ["value", "label", "readonly"],
    data() {
        return {
            descriptionValue: null,
            customCodeValue: null
        };
    },
    watch: {
        customCodeValue(val) {
            // this.$emit("input", val);
            if (this.selectedPluginData.nodeType === "CUSTOM") {
                this.value.customCode = val;
            } else {
                this.value.condition = val;
            }

            this.$store.commit("smartContractDesigner/setChangesOnCurrentData", this.value);
        },
        descriptionValue(val) {
            this.value.description = val;
            this.$store.commit("smartContractDesigner/setChangesOnCurrentData", this.value);
        },
        selectedPluginData: {
            handler(newVal) {
                if (newVal) {
                    this.selectPlugin(newVal);
                }
            }
        }
    },
    mounted() {
        this.selectPlugin();
    },
    methods: {
        selectPlugin(val) {
            const selectData = val || this.selectedPluginData;
            if (selectData && selectData.nodeType === "CUSTOM") {
                this.customCodeValue = selectData.customCode ? selectData.customCode : "";
            } else if (selectData && selectData.nodeType !== "CUSTOM") {
                this.customCodeValue = selectData.condition ? selectData.condition : "";
            } else {
                this.customCodeValue = "";
            }
            this.descriptionValue = selectData ? selectData.description : "";
        },
        setLabel() {
            if (this.selectedPluginData.nodeType === "CUSTOM") {
                return this.$t("smartContract.assignHandler.custom");
            }
            return this.$t("smartContract.assignHandler.condition");
        },
        selectedVariable(val) {
            this.customCodeValue += val.label;
        },
        changeDescription(val) {
            this.descriptionValue = val;
        }
    },
    valueChanged() {}
};
